import { axiosInstance } from "@/axios/interceptors";
import type { LoginParam } from "@/common/types";

export default {
  login: (data: LoginParam) => axiosInstance.post("login", data),
  logout: () => axiosInstance.get("logout"),
  checkSession: () => axiosInstance.get("whois"),
  cryptoToken: (businessno:any) => axiosInstance.get("nice/crypto-token", { params: { businessno : businessno } }),
  tokenCallback: (data:any) => axiosInstance.get("nice/callback", { params: data }),
  oauth: () => axiosInstance.get("oauth"),
};
